import Utility from "Utility";

export default $(()=>{

    let $footerPrimary = $('footer.primary');
    let delay = $footerPrimary.outerHeight() / 2;
    let footerAnimated = false;


    if (Utility.isInView('footer.primary', delay)) {
        $footerPrimary.addClass('open');
    }

    $(window).on('scroll', () => {
        if (!footerAnimated) {
            let inView = Utility.isInView('footer.primary', delay);
            if (inView) {
                $footerPrimary.addClass('open');
                footerAnimated = true;
            }
        }
    });

});